var resources = require('items-view-strings');
    var strings = resources['_Cr1zL57Z60DXVZgllyL25A'];
export { strings };
export default strings;
